import annotationList from "./annotationList";
import citation from "./citation";
import editor from "./editor";
import footerButton from "./footerButton";
import groupOptions from "./groupOptions";
import list from "./list";
import marker from "./marker";
import meta from "./meta";
import selection from "./selection";
import tag from "./tag";

export default `
  ${annotationList}
  ${citation}
  ${editor}
  ${footerButton}
  ${groupOptions}
  ${list}
  ${marker}
  ${meta}
  ${selection}
  ${tag}
`;
